<template>
  <el-dialog
    title="添加标签"
    :center="false"
    width="80%"
    :visible.sync="dialogTableVisible"
    :close-on-click-modal="false"
    @closed="$emit('close')"
  >
    <div class="content">
      <el-autocomplete
        v-model="addIfon.platformId"
        :fetch-suggestions="querySearchAsyncPlatform"
        placeholder="请输入平台"
        style="margin-right:20px"
        @select="handleSelectPlatform"
      />
      <el-autocomplete
        v-model="addIfon.tagType"
        :fetch-suggestions="querySearchAsyncLabel"
        placeholder="请输入标签"
        @select="handleSelectLabel"
      />
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="determine">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { addPlatformLabel } from '@/api/platformLabel.js'
export default {
  props: {
    baseTag: {
      type: Object,
      default() {
        return {}
      }
    },
    platforms: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      dialogTableVisible: true,
      addIfon: {
        platformId: '',
        tagType: ''
      }
    }
  },
  created() {
    // console.log(this.baseTag, this.platforms)
  },
  methods: {
    async determine() {
      const new1 = this.platforms.filter(item => item.name === this.addIfon.platformId)
      const new2 = Object.keys(this.baseTag).map((key) => { return { ...this.baseTag[key] } }).filter(item => item.title === this.addIfon.tagType)

      const data = {
        platform_id: new1.length ? new1[0].id : undefined,

        tag_type: new2.length ? new2[0].tagType : undefined
      }
      if (this.verification(data)) {
        await addPlatformLabel(data)
        this.$message({
          message: '添加成功',
          type: 'success'
        })
        this.$emit('colse', 'true')
      }
    },
    async querySearchAsyncLabel(queryString, cb) {
      let newArr = Object.keys(this.baseTag).map((key) => {
        return {
          ...this.baseTag[key],
          value: this.baseTag[key].title,
          address: this.baseTag[key].tagType
        }
      })
      newArr = newArr.filter(item => item.value.includes(queryString))
      cb(newArr)
    },
    async querySearchAsyncPlatform(queryString, cb) {
      let newArr = this.platforms.map((item) => {
        return {
          ...item,
          value: item.name,
          address: item.id
        }
      })
      newArr = newArr.filter(item => item.value.includes(queryString))
      cb(newArr)
    },

    handleSelectLabel(item) {

    },
    handleSelectPlatform(item) {

    },
    verification(data) {
      if (!data.platform_id || !data.tag_type) {
        this.$message({
          message: !data.platform_id ? '请选择平台' : '请选择标签',
          type: 'warning'
        })
        return false
      }
      return true
    }
  }
}
</script>

<style lang="less" scoped>
.content{

}
</style>
